/**
 * @typedef {Object} IdentityType
 * @property {'passport'} Passport паспорт
 * @property {'id'} Id удостоверение личности (ID)
 */

/** @type {Readonly<IdentityType>} */
const identityType = {
    Passport: 'passport',
    Id: 'id',
};

/**
 * @typedef {Object} IdentityTypeItem
 * @property {string} caption надпись
 * @property {string} type техническое название
 */

/** @type {Record<IdentityType, IdentityTypeItem>} */
const identityTypes = {
    [identityType.Passport]: {
        type: identityType.Passport,
        caption: 'Паспорт',
    },
    [identityType.Id]: {
        type: identityType.Id,
        caption: 'ID',
    },
};

module.exports = {
    IDENTITY_TYPE: identityType,
    IDENTITY_TYPES: identityTypes,
};
